var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"padding":"0 10px"}},_vm._l((_vm.content),function(item,i){return _c('div',{key:i},[_c('a-icon',{attrs:{"type":"notification"}}),_vm._v(" "+_vm._s(item.title)+"\n")],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }